'use strict'

const Bucket = require('./bucket')

module.exports = function createHAMT (options) {
  return new Bucket(options)
}

module.exports.isBucket = Bucket.isBucket



//////////////////
// WEBPACK FOOTER
// ./~/ipfs-unixfs-engine/src/hamt/index.js
// module id = 502
// module chunks = 0